import { Injectable, signal, type Signal, type WritableSignal } from '@angular/core';

function incrementValue(value: number): number {
  return value + 1;
}

@Injectable({ providedIn: 'root' })
export class CatalogInvalidationService {
  private readonly versions = new Map<string, WritableSignal<number>>();

  version(key: string): Signal<number> {
    return this.getSignal(key);
  }

  invalidate(key: string): void {
    this.getSignal(key).update(incrementValue);
  }

  private getSignal(key: string): WritableSignal<number> {
    const existingSignal = this.versions.get(key);
    if (existingSignal) {
      return existingSignal;
    }

    const nextSignal = signal(0);
    this.versions.set(key, nextSignal);
    return nextSignal;
  }
}
